/* global jQuery */

const $ = jQuery;

function manipulateVideos( element, action ) {
	$( element ).find( 'video, iframe' ).each( function() {
		const video = $( this ).data( 'video' ) || this;
		if ( typeof video[ action ] !== 'undefined' ) {
			video[ action ]();
		}
	} );
}

export function playVideos( element ) {
	manipulateVideos( element, 'play' );
}

export function pauseVideos( element ) {
	manipulateVideos( element, 'pause' );
}
